export default __webpack_public_path__ + "static/media/ScratchTemplate.492e4d73.svg";